<template>
  <el-card class="card linkFormClassifyCard">
    <div slot="header" class="linkFormClassifyCard__header">
      <strong class="linkFormClassifyCard__title">关联分类</strong>
    </div>
    <div class="linkFormClassifyCard__body">
      <div class="linkFormClassifyCard__row">
        <div class="linkFormClassifyCard__tags">
          <el-tag
            v-for="name in displayNames"
            :key="name"
            closable
            :disable-transitions="false"
            class="linkFormClassifyCard__tag"
            @close="removeByName(name)"
          >
            {{ name }}
          </el-tag>
          <span v-if="!displayNames.length" class="linkFormClassifyCard__empty">
            暂未关联分类
          </span>
        </div>
        <button
          type="button"
          class="linkFormClassifyCard__addBtn"
          @click="openPicker"
        >
          <i class="el-icon-plus" aria-hidden="true" />
          添加分类
        </button>
      </div>
    </div>

    <association-picker-dialog
      title="关联分类"
      :visible.sync="pickerOpen"
      @confirm="applyPicker"
      @cancel="discardPicker"
      @closed="discardPicker"
    >
      <link-category-picker
        v-model="draftNames"
        :category-type="type"
      />
    </association-picker-dialog>
  </el-card>
</template>

<script>
import AssociationPickerDialog from './AssociationPickerDialog.vue'
import LinkCategoryPicker from './categoryPicker.vue'

/**
 * 通用资源创建/编辑 · 关联分类区块。
 * 单行布局：左侧 chip / 空态，右侧「+ 添加分类」。
 */
export default {
  name: 'LinkFormClassifyCard',
  components: {
    AssociationPickerDialog,
    LinkCategoryPicker,
  },
  props: {
    dynamicTagsList: {
      type: Array,
      default: () => [],
    },
    type: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pickerOpen: false,
      draftNames: [],
    }
  },
  computed: {
    displayNames() {
      return Array.isArray(this.dynamicTagsList) ? this.dynamicTagsList : []
    },
  },
  methods: {
    openPicker() {
      this.draftNames = [...this.displayNames]
      this.pickerOpen = true
    },
    applyPicker() {
      this.$emit('update:dynamicTagsList', [...this.draftNames])
    },
    discardPicker() {
      this.draftNames = [...this.displayNames]
    },
    removeByName(name) {
      const next = this.displayNames.filter((item) => item !== name)
      this.$emit('update:dynamicTagsList', next)
    },
  },
}
</script>

<style scoped>
.linkFormClassifyCard__header {
  display: flex;
  align-items: center;
}

.linkFormClassifyCard__title {
  font-size: 14px;
}

.linkFormClassifyCard__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.linkFormClassifyCard__tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.linkFormClassifyCard__tag {
  margin: 0;
}

.linkFormClassifyCard__empty {
  font-size: 12px;
  color: var(--link-ink-muted, #78716c);
  line-height: 28px;
}

.linkFormClassifyCard__addBtn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  min-height: 28px;
  padding: 0 12px;
  border: 1px dashed var(--link-accent-border, #cce5ff);
  border-radius: 999px;
  background: var(--link-accent-bg, #f0f7ff);
  font-size: 12px;
  font-weight: 500;
  color: var(--link-accent, #2563eb);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.linkFormClassifyCard__addBtn:hover {
  border-color: var(--link-accent, #2563eb);
  background: var(--link-accent-soft, rgba(37, 99, 235, 0.07));
  color: var(--link-accent-hover, #1d4ed8);
}
</style>
